var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("span", [
    _vm.isCheck
      ? _c("i", { staticClass: "uk-icon-check green" })
      : _c("i", { staticClass: "uk-icon-times red" }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }